import styled from 'styled-components';
import { header2, header1 } from '@westwing/ui-kit/typography';
import { forTablet } from '@westwing/ui-kit/breakPoints';

const Heading = styled.h2`
    ${header1}

    ${forTablet`
        ${header2}
    `}

    color: ${({ theme }) => theme.colors.charcoal100};
    margin-top: 0;
    margin-bottom: 1rem;
    line-height: 1.5;
`;

export default Heading;
